<h2 mat-dialog-title translate style="margin:0;color: #b71c1c; display: flex; justify-content: center;" translate>ATTENTION</h2>
<mat-dialog-content>
    <quill-editor 
        [ngModel]="message | tylTranslate | translate"
        [readOnly]="true" placeholder="No text entered" class="ql-textOnly" [name]="'CMText'">
    </quill-editor>
</mat-dialog-content>
<mat-dialog-actions>
    <div class='flex-footer-left'>

    </div>
    <div class='flex-footer-right'>
        <tyl-button image="cancel.png" label="Close" (clickEvent)="cancelClick()"></tyl-button>
    </div>
</mat-dialog-actions>